import { fetchCategory } from '../../../../fetchers/categories';
import { ICategory } from '../../../../models';
import { AlternateLangs } from '../../../../models/app';
import CategoryPage from '../../../../components/CategoryPage';
import MyHead from '../../../../components/MyHead';
import Footer from '../../../../components/Footer';
import Menu from '../../../../components/Menu/Menu';
import {
  getLangCountry,
  getRealLangCountry,
  SUPPORTED_LANG
} from '../../../../helpers/languages';
import { fetchAlternateUrls } from '../../../../fetchers/commons';
import { GetStaticPropsContext } from 'next';
import { SUPPORTED_COUNTRY } from '../../../../helpers/countries';

function Products({
  alternates = [],
  category
}: {
  alternates: AlternateLangs[];
  category: ICategory;
}) {
  return (
    <>
      <MyHead alternates={alternates} />
      <div>
        <Menu />
        <CategoryPage category={category} />
        <Footer />
      </div>
    </>
  );
}

export async function getStaticProps(context: GetStaticPropsContext) {
  const { params } = context;
  const { lang, country } = getLangCountry(params);
  const apiParams = { lang, country };

  const real = getRealLangCountry(params);
  if (
    !SUPPORTED_LANG.includes(real.lang) ||
    !SUPPORTED_COUNTRY.includes(real.country)
  ) {
    return { notFound: true };
  }

  const slug: string[] =
    params && params.slug
      ? typeof params.slug === 'string'
        ? params.slug.split('/').filter((s: string) => s)
        : params.slug
      : [''];

  const [category, alternates] = await Promise.all([
    fetchCategory({
      ...apiParams,
      slug: slug.join('/')
    }),
    fetchAlternateUrls({
      url: slug,
      lang,
      country,
      prefix: '/shop'
    })
  ]);

  if (!category) {
    return { notFound: true, revalidate: 60 };
  }

  return {
    props: {
      alternates,
      category
    },
    // eslint-disable-next-line unicorn/numeric-separators-style
    revalidate: 86_400
  };
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  };
}

export default Products;
